// extracted by mini-css-extract-plugin
export default {"Input":"SpecialOrder_Input__AFXbu","Desc":"SpecialOrder_Desc__UN8qY"};